import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgAbkhazia = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 7" {...props}>
    <path d="M0 0h14v7H0V0z" fill="#00993E" />
    <path d="M0 1h14v1H0V1zm0 2h14v1H0V3zm0 2h14v1H0V5z" fill="#FFF" />
    <path d="M0 0h5.32v3H0V0z" fill="#C8312A" />
    <path
      d="M2.248 1.676s-.046.019-.014.385c.025.301.133.4.133.4l.047.186.444.002s.008-.116.026-.152c.042-.09.21-.193.281-.347.078-.095.039-.287.194-.473.077-.093-.09-.054-.09-.054a.437.437 0 0 0-.16.183c-.015.096-.087.176-.094.106 0 0-.026-.12-.105-.355-.007-.07-.041-.31-.048-.494-.005-.119-.11-.126-.119-.005l-.012.48-.025-.554C2.696.827 2.576.85 2.57.98l-.005.578-.022-.56c-.032-.107-.116-.044-.118.072l-.014.545s-.019-.298-.023-.424c-.004-.076-.092-.07-.1.038-.013.156-.032.284-.04.447zM2.525.653 2.66.237l.135.416-.354-.258h.438l-.354.258zm1.051.166L3.222.56h.438l-.354.26.134-.417.135.416zm.668.494-.354-.257h.438l-.354.257.135-.416.135.416zm.387.698-.354-.257h.438l-.354.257.135-.416.135.416zM1.744.819 2.098.56H1.66l.354.258L1.88.403l-.135.416zm-.668.494.354-.257H.992l.354.257-.135-.416-.135.416zm-.387.698.354-.257H.605l.354.257-.135-.416-.135.416z"
      fill="#FFF"
    />
  </svg>
);
const Memo = memo(SvgAbkhazia);
export default Memo;
